import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component HashtagIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <HashtagIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <HashtagIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const HashtagIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    svgRef?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="HashtagIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.33 21l.719-4H2l.354-2h4.049l1.073-6H3.427l.354-2H7.83l.719-4h2.024l-.719 4h6.073l.719-4h2.024l-.719 4H22l-.354 2h-4.049l-1.073 6h4.049l-.354 2H16.17l-.719 4h-2.024l.719-4H8.073l-.719 4H5.33zM9.5 9l-1.073 6H14.5l1.073-6H9.5z"
      />
    </svg>
  )
);
HashtagIcon.displayName = "HashtagIcon";
export default HashtagIcon;
